import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";

// Async action to handle Google login and fetching profile
export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async (accessToken, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`
      );
      const userData = res.data;

      const data = {
        email: userData.email,
        name: userData.name,
        socialID: userData.id,
        socialType: "google",
      };

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/social/login`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: JSON.stringify(data),
      };

      const response = await axios(config);
      const token = response.data.token;

      if (token) {
        localStorage.setItem("token", token);
      }
      toast.success("Login Successful");
      return { profile: userData, token };
    } catch (error) {
      toast.error("Login Failed: " + error.message);
      return rejectWithValue(error.message);
    }
  }
);

const googleAuthSlice = createSlice({
  name: "googleAuth",
  initialState: {
    profile: null,
    token: null,
    error: null,
    loading: false,
  },
  reducers: {
    logout: (state) => {
      state.profile = null;
      state.token = null;
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("name");
      localStorage.removeItem("token");
      googleLogout();
      toast.success("Logged out successfully");
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.profile;
        state.token = action.payload.token;
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("name", action.payload.profile.name);
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login Failed";
      });
  },
});

export const { logout } = googleAuthSlice.actions;

export default googleAuthSlice.reducer;
 










